<template>
 <section class="modal__action">
    <div class="action" :class="statusActions.class" :data-cy="statusActions.name === 'Desativar'
      ? 'desactivate-captation-unit-btn'
      : 'reactivate-captation-unit-btn'" @click="send()">
      <div class="indicator"></div>
      <span> {{ statusActions.name }}</span>
    </div>
  </section>
</template>
<script>
import { mapActions } from "vuex"; 
import axios from "@/axios";
export default {
  name: "ChangeStatuscomp",

  props: {
    resource: {
      type: Object,
    },

    typeData: {
      type: String,
    },

    url: {
      type: String,
    },
  },

  computed: {
    statusActions() {
      const isNotNull = this.resource.deleted_at != null;

      return {
        name: isNotNull ? "Reativar" : "Desativar",
        type: isNotNull ? "PUT" : "DELETE",
        class: isNotNull ? "active" : "delete",
        route: isNotNull
          ? `/${this.url}/restore/${this.resource.id}`
          : `/${this.url}/${this.resource.id}`,
      };
    },
  },

  methods: {
    ...mapActions(["changeDefaultModalInfos", "changeSnackBarData"]),

    send() {
      axios({
        method: this.statusActions.type,
        url: this.statusActions.route,
      })
        .then((response) => {
          this.changeSnackBarData({
            status: true,
            type: "success",
            titleMessage: response.data.message,
            bodyMessage: "",
            cardColor: "#41916b",
            titleIcon: "mdi-checkbox-marked-circle",
          });

          setTimeout(() => {
            this.$emit("updateGrid");
            this.closeSnackBar();
          }, 3000);
        })
        .catch((err) => { 
          this.changeSnackBarData({
            status: true,
            type: "erro",
            titleMessage: "Ocorreu um erro",
            bodyMessage: err.error,
            cardColor: "red",
            titleIcon: "mdi-close-circle",
          });

          setTimeout(() => {
            this.closeSnackBar();
          }, 5000);
        });
    },

    closeSnackBar() {
      this.changeSnackBarData({
        status: false,
        type: "",
        titleMessage: "",
        bodyMessage: "",
        cardColor: "",
        titleIcon: "",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.modal__action {
  width: 100%;

  .action {
    display: flex;
    width: 100%;
    align-items: center;
    margin: 3px 0;
    padding: 10px 0 10px 10px;
    border-radius: 10px !important;

    .indicator {
      height: 20px;
      width: 4px;
      border-radius: 10px;

      margin: 0 8px 0 0;
    }

    span {
      font-size: 14px;
      font-weight: 500;
    }
  }

  .action:hover {
    background: blue;
    cursor: pointer;

    .indicator {
      background: blue;
    }

    span {
      color: blue;
    }
  }

  .active {
    background: rgb(10, 155, 29);

    .indicator {
      background: rgb(255, 255, 255);
    }

    span {
      color: rgb(255, 255, 255);
    }
  }

  .active:hover {
    background: rgb(7, 139, 25);
    cursor: pointer;

    .indicator {
      background: rgb(255, 255, 255);
    }

    span {
      color: rgb(255, 255, 255);
    }
  }

  .active_delete {
    background: blue;
    cursor: pointer;

    .indicator {
      background: blue;
    }

    span {
      color: blue;
    }
  }
  .active_delete:hover {
    background: blue;
    cursor: pointer;

    .indicator {
      background: blue;
    }

    span {
      color: blue;
    }
  }

  .delete {
    background: #eb4949;

    .indicator {
      background: rgb(255, 255, 255);
    }

    span {
      color: rgb(255, 255, 255);
    }
  }

  .delete:hover {
    background: #eb3e3e;
    cursor: pointer;

    .indicator {
      background: rgb(255, 255, 255);
    }

    span {
      color: rgb(255, 255, 255);
    }
  }
}
</style>
